import type { LayerChangedEvent, Manifest, ManifestLayer } from '../api/types';

/** Parse one SSE data payload; null when it is not a layer change. */
export function parseLayerEvent(data: string): LayerChangedEvent | null {
  try {
    const x = JSON.parse(data) as unknown;
    if (typeof x !== 'object' || x === null) return null;
    const { layer_id, content_hash } = x as Record<string, unknown>;
    if (typeof layer_id !== 'string') return null;
    if (typeof content_hash === 'string' || content_hash === null) return { layer_id, content_hash };
    return null;
  } catch {
    return null;
  }
}

/** True when the event announces data the current manifest does not have yet. */
export function isStale(manifest: Manifest | null, event: LayerChangedEvent): boolean {
  if (!manifest) return false;
  const entry = manifest.layers.find((l) => l.layer_id === event.layer_id);
  if (event.content_hash === null) return entry !== undefined;
  return !entry || entry.content_hash !== event.content_hash;
}

/** Layers whose content changed (or appeared) between two manifests. */
export function changedLayers(prev: Manifest | null, next: Manifest): ManifestLayer[] {
  const before = new Map((prev?.layers ?? []).map((l) => [l.layer_id, l.content_hash]));
  return next.layers.filter((l) => before.get(l.layer_id) !== l.content_hash);
}
